import React, { useContext,useState } from 'react'
//import './FilterForm.css'
import {dataContext,localestr} from '../utils.js'
import EditCtrl from './EditCtrl.js'

function WeightForm({capt1,capt2,number,setModal,action,disable}){
    const [numb,setNumb]=useState(number)

    const context=useContext(dataContext)
    const msg_arr=context.msg_arr

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }
  
    function elementDrag(e) {
      const elmnt=document.getElementById('modalWnd')
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }
  
    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }

    function keyClick(e){
      if(e.key==='Enter') {setModal('');action(numb)}
      else if(e.key==='Escape') setModal('')
    }

    const weightClick=async()=>{
      const w_type=localStorage.getItem('w_type')
      if(!w_type) {
          msg_arr(localestr('Виберіть модель ваг'),'',[{caption:'NT-15',action:()=>{localStorage.setItem('w_type','NT-15');weightClick()}},{caption:'Ягуар',action:()=>{localStorage.setItem('w_type','Jaguar');weightClick()}}])
          return
      }
      if ("serial" in navigator) {
          const ports = await navigator.serial.getPorts();
          let port = ports[0];
          if(!port) port = await navigator.serial.requestPort();
          if(w_type==='NT-15'){
              try {
              await port.open({baudRate:4800, dataBits:8, stopBits:1, parity:'even'});
              } catch (error) {
              console.log(error)
              return;
              }
              let timerId = setTimeout(()=>port.close(),3000)
              
              const writer = port.writable.getWriter();
              await writer.write(new Uint8Array([0]));
              await writer.write(new Uint8Array([0]));
              await writer.write(new Uint8Array([3]));
              writer.releaseLock();
              
              let w='';
        
              while (port.readable) {
              const reader = port.readable.getReader({mode:'byob'});
              let timer2Id = setTimeout(()=>reader.releaseLock(),2000)
              try {
                  while (true) {
                  let buffer = new ArrayBuffer(16);
                  const { value, done } = await reader.read(new Uint8Array(buffer));
                  if (done) break;
                  if(w.length<6){
                      for(let i=0;i<6;i++) w=String.fromCharCode(value[i])+w;
                  }
                  if(value.length<8) break;
                  }
              } catch (error) {
                  // Handle |error|…
                  console.log(error);
              } finally {
                  reader.releaseLock();
                  clearTimeout(timer2Id);
                  await port.close();
                  clearTimeout(timerId);
              }
              }
              setNumb(parseInt(w||0)/1000)
          } else if(w_type==='Jaguar'){
              try {
              await port.open({baudRate:4800, dataBits:8, stopBits:1});
              } catch (error) {
              console.log(error)
              return;
              }
              let timerId = setTimeout(()=>port.close(),3000)
              
              const writer = port.writable.getWriter();
              await writer.write(new Uint8Array([80]));
              writer.releaseLock();
              
              let w='';
          
              while (port.readable) {
              const reader = port.readable.getReader({mode:'byob'});
              let timer2Id = setTimeout(()=>reader.releaseLock(),2000)
              try {
                  while (true) {
                  let buffer = new ArrayBuffer(16);
                  const { value, done } = await reader.read(new Uint8Array(buffer));
                  if (done) break;
                  if(w.length<6){
                      for(let i=0;i<6;i++) w+=String.fromCharCode(value[i]);
                  }
                  if(value.length<8) break;
                  }
              } catch (error) {
                  // Handle |error|…
                  console.log(error);
              } finally {
                  reader.releaseLock();
                  clearTimeout(timer2Id);
                  await port.close();
                  clearTimeout(timerId);
              }
              }
              setNumb(parseFloat(w||0))
          }
      }
  }

    return(
        <div className='modal_f'><div id='modalWnd' className='window'>
            <div onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{capt1}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
            <div className='content'>
            <div onKeyUp={keyClick} style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <EditCtrl Capt={capt2} Value={numb} typeVal={'number'} setVal={setNumb} width1='65' width2='120' isActive={true} disabled={disable} />
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{weightClick()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Вага')}</div></div>
            </div>
            <div style={{margin:'10px 0 0 0',display:'flex',justifyContent:'center'}}>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('');action(numb)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
            <div style={{width:'80px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{setModal('')}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Закрити')}</div></div>
            </div></div>
        </div></div>
    )
}

export default WeightForm